(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Ingrediet-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('.ing-acc__toggle');
      if (!toggle) return;

      var row = toggle.closest('[data-ing-row]');
      var section = toggle.closest('[data-ing-acc]');
      if (!row || !section) return;

      var panelId = toggle.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : row.querySelector('.ing-acc__panel');
      if (!panel) return;

      var isOpen = row.classList.contains('is-open');

      section.querySelectorAll('[data-ing-row].is-open').forEach(function (otherRow) {
        if (otherRow === row) return;
        otherRow.classList.remove('is-open');
        var otherToggle = otherRow.querySelector('.ing-acc__toggle');
        var otherPanel = otherRow.querySelector('.ing-acc__panel');
        if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        if (otherPanel) otherPanel.setAttribute('hidden', '');
      });

      if (isOpen) {
        row.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        panel.setAttribute('hidden', '');
      } else {
        row.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        panel.removeAttribute('hidden');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
